<div (click)="onBackdropClick()"
     id="shared-modal-content-projection-backdrop">
</div>

<div id="shared-modal-content-projection-container">

  <div
    [ngClass]="{
      'large': modalSize === modalSizeEnum.LARGE,
      'medium': modalSize === modalSizeEnum.MEDIUM,
      'small': modalSize === modalSizeEnum.SMALL,
    }"
    class="modal-container">

    <app-shared-modal-header
      (emitClose)="onCloseModalClick()"
      [isCloseIconVisible]="isHeaderCloseIconVisible"
      [applyTitle]="modalTitle">
    </app-shared-modal-header>

    <div class="content-for-modal" [ngClass]="{'no-title': !modalTitle }">
      <ng-content select=".content"></ng-content>
    </div>

  </div>

</div>
